<template>
  <div id="lookcreator" class="w-100">
    <!-- Usamos el mismo del filtro de los tienda de tickets apracados -->
     <v-toolbar class="sub-toolbar" flat>
      <v-btn flat class="primary-color back mr-auto" :to="'/looks'"><v-icon class="mr-2">arrow_back</v-icon>{{ $t('lang.comun.salir') }}</v-btn> 
       <Menu>
        <template v-slot:tickets-aparcados>&nbsp;</template>
        <template v-slot:carrito>&nbsp;</template>
      </Menu>
     </v-toolbar>
  
    <div class="tienda-container go-right">

    <div class="pt-4 product-canvas px-4 text-right">
        <div id="canvas-container" ref="dropzone" class="boardRight" @drop.prevent="handleDrop"  @dragover.prevent="handleDragOver">
          <canvas class="elevation-1" id="canvas" ref="can"></canvas>

        </div>
        <v-text-field v-model="titulo" label="Titulo" />
        <v-text-field v-model="descripcion" label="Descripción" />
    </div>
          <!--<v-btn class="unishop-button-secondary unishop-keep-shopping" @click="borrar()">Borrar</v-btn>-->
              <v-btn class="white--text primary secundario" fab icon right bottom @click="reiniciarLook()" ><v-icon>restart_alt</v-icon></v-btn>
              <v-btn class="orange white--text unishop-keep-shopping guardar" absolute bottom right large fab icon  @click="guardarLook()"><v-icon>save</v-icon></v-btn>

    <div class="">
        <ProductsList :tienda="false"></ProductsList>
      </div>
    </div>
  </div>
</template>

<script>
import { fabric } from 'fabric';
import Menu from '@/views/tienda/components/menu/Menu.vue';
import ProductsList from '@/views/tienda/components/products_list/ProductsListContainer';

import { LookApiService } from '@/api/LookApiService'
import { Util } from '@/api/Util'

const lookApiService = new LookApiService()
const util = new Util()

export default {
  name: "LookCreator",
  props: ['lookid'],
  data() {
    return {
      canvas : '',
      elementosDropped : [],
      titulo: '',
      descripcion: '',
      idLook: null,
      user: this.$store.getters.getUserName,
      left: 10,
      top: 10
    }
  },
  components : {
    Menu,
    ProductsList
  },
  mounted() {
    /** */
    this.$root.$on('addToCanvas', (event) => {
        this.handleTouchDrop(event)
    });
    /** */
    const ref = this.$refs.can;
    this.canvas = new fabric.Canvas(ref,{ stateful: true})
    this.canvas.on('object:moving', this.moveHandler)
    //funcion que mueve el objeto a la posicion original
    this.canvas.on('object:modified', this.preventBound)
    this.canvas.preserveObjectStacking = true
    this.canvas.setHeight(document.getElementById('canvas-container').offsetHeight-10)
    this.canvas.setWidth(document.getElementById('canvas-container').offsetWidth-10)
    this.canvas.backgroundColor="white"
    this.canvas.renderAll()
    this.idLook = this.lookid
    if (typeof(this.idLook) != 'undefined' && this.idLook != null) {
      this.getLook()
    }
  },
  created () {
    this.cambioTitulo()
    this.$store.commit('showCarritoModal', false)
    this.$store.commit('showTickets', false)
    this.$store.commit('showFiltro', false)
    this.$store.commit('showFiltroTickets', false)
    this.$store.commit('showBusqueda', false)
  },
  methods: {
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">content_cut</v-icon>`
      this.$store.state.titulo = "Look creator"
    },
    handleDragStart(e) {
      var images = document.querySelectorAll('.productos-look img');
      [].forEach.call(images, function (img) {
          img.classList.remove('img_dragging');
      });
      e.currentTarget.classList.add('img_dragging');
    },

    handleDragOver(e) {
      if (e.preventDefault) {
          e.preventDefault(); // Necessary. Allows us to drop.
      }

      e.dataTransfer.dropEffect = 'copy'; // See the section on the DataTransfer object.
      // NOTE: comment above refers to the article (see top) -natchiketa

      return false;
    },

    handleDragEnter(e) {
          // this / e.target is the current hover target.
          this.classList.add('over');
    },

    handleDragLeave(e) {
        this.classList.remove('over'); // this / e.target is previous target element.
    },

    handleDrop(e) {
    // this / e.target is current target element.

      if (e.stopPropagation) {
          e.stopPropagation(); // stops the browser from redirecting.
      }

      var img = document.querySelector('.productos-look img.img_dragging');
      var idimg = img.attributes.idFoto.value
      //console.log('event: ', e);
      let scalex = img.width / img.naturalWidth;
      let scaley = img.height / img.naturalHeight;
      var newImage = new fabric.Image(img, {
          // width: img.width,
          // height: img.height,
          scaleX: scalex,
          scaleY: scaley,
          // Set the center of the new object based on the event coordinates relative
          // to the canvas container.
          left: e.layerX,
          top: e.layerY,
          id: img.id,
          idFoto: idimg
          // crossOrigin: 'anonymous'
      });
      this.canvas.add(newImage);
      this.canvas.renderAll();
      var encontrado = -1;
      for( var i = 0, len = this.elementosDropped.length; i < len; i++ ) {
          if( this.elementosDropped[i] === idimg) {
            encontrado = i;
            break;
          }
      }
      if (encontrado === -1) {
          this.elementosDropped.push(idimg);  
      }
      // return false;
    },
    handleTouchDrop(e) {
      if (e.stopPropagation) {
          e.stopPropagation() // stops the browser from redirecting.
      }

      var img = e
      var idimg = img.attributes.idFoto.value
      //console.log('event: ', e);
      let scalex = img.width / img.naturalWidth;
      let scaley = img.height / img.naturalHeight;
      var newImage = new fabric.Image(img, {
          // width: img.width,
          // height: img.height,
          scaleX: scalex,
          scaleY: scaley,
          // Set the center of the new object based on the event coordinates relative
          // to the canvas container.
          left: this.left,
          top: this.top,
          id: img.id,
          idFoto: idimg
          // crossOrigin: 'anonymous'
      });
      this.left += 20
      this.top += 20 
      this.canvas.add(newImage)
      this.canvas.renderAll()
      var encontrado = -1
      for( var i = 0, len = this.elementosDropped.length; i < len; i++ ) {
          if( this.elementosDropped[i] === idimg) {
              encontrado = i;
              break;
          }
      }
      if (encontrado === -1) {
          this.elementosDropped.push(idimg);  
      }
    },
    handleDragEnd(e) {
    // this/e.target is the source node.
      var images = document.querySelectorAll('.productos-look img');
      [].forEach.call(images, function (img) {
          img.classList.remove('img_dragging');
      });
    },
    borrar() {
      this.canvas.remove(this.canvas.getActiveObject());
      this.canvas.renderAll()   
    },
    getLook() {
      lookApiService.getLookById(this.idLook)
        .then(data => {
          console.log(data)
          this.titulo = data.mslTitulo
          this.descripcion = data.mslDesc
          for (var i=0; i<data.lookArticulos.length; i++) {
          
            let url = this.getFoto(data.lookArticulos[i].articulo, data.lookArticulos[i].mslaIdFoto)
            var that = this
            let dataAux = data.lookArticulos[i]

            let proporcion = 1 
            // calculamos la proporcion a aumentar o disminuir dependiendo del tamaño del canvas con el que se guardo el look
            proporcion = this.canvas.width / dataAux.mslaAnchoCanvas
      
            fabric.Image.fromURL(url, (image) => {
                image.set({
                  // width: data.lookArticulos[i].mslaAncho,
                  // height: data.lookArticulos[i].mslaAlto,
                  angle: dataAux.mslaRotacion,
                  scaleX: (dataAux.mslaAncho / image.width) * proporcion,
                  scaleY: (dataAux.mslaAlto / image.height) * proporcion,
                  left: dataAux.mslaCordX * proporcion,
                  top: dataAux.mslaCordY * proporcion,
                  id: dataAux.articulo.id,
                  mslaId: dataAux.mslaId,
                  mslaUid: dataAux.mslaUid,
                  idFoto: dataAux.mslaIdFoto
                });
                that.canvas.add(image);
                that.canvas.renderAll();
            });
          }
        })
    },
    getFoto(productAux, idFoto) {
      let url = ''
      if (productAux.fotos) {
        for (var i = 0; i < productAux.fotos.length; i++) {
          if (productAux.fotos[i].id === idFoto) {
              url=productAux.fotos[i].url
          }
        }
      } 
      if (url === '') {
        return require('@/assets/images/noimg.jpg')
      } else {
        return url
      }
    },
    guardarLook(){
      if (this.canvas.getObjects.length > 0) {
        //console.log(this.canvas.getObjects())
        // var url = this.canvas.toDataURL("image/png");
        // url = url.replace('data:image/png;base64,','')
        // console.log(url)
        // var w=window.open('about:blank','image from canvas');
        // w.document.write("<img src='"+url+"' alt='from canvas'/>");
        
        var look = {
          mslTitulo : this.titulo,
          mslDesc : this.descripcion,
          mslUsuCre: this.user.substring(0,50)
          // msl_imagen : this.base64ToArrayBuffer(url)
        }
        let lookArticulosAux= {
						lookArticulos : []
				}
        for (var i = 0; i < this.canvas.getObjects().length; i++) {
					let lookArticuloAux= {
            mslaCordX : Math.round(this.canvas.getObjects()[i].left),
            mslaCordY : Math.round(this.canvas.getObjects()[i].top),
            mslaAlto: Math.round(this.canvas.getObjects()[i].height * this.canvas.getObjects()[i].scaleY),
            mslaAncho: Math.round(this.canvas.getObjects()[i].width * this.canvas.getObjects()[i].scaleX),
            mslaIdArtic: this.canvas.getObjects()[i].id,
            mslaId: this.canvas.getObjects()[i].mslaId,
            mslaUid: this.canvas.getObjects()[i].mslaUid,
            mslaRotacion: Math.round(this.canvas.getObjects()[i].angle),
            mslaAnchoCanvas: this.canvas.width,
            mslaIdFoto: this.canvas.getObjects()[i].idFoto
          }
					lookArticulosAux.lookArticulos.push(lookArticuloAux)
        }
        Object.assign(look, lookArticulosAux)
        var canvasAux = this.canvas.toCanvasElement()
        if (typeof(this.idLook) != 'undefined' && this.idLook != null) {
          let mslId = {
            mslId : this.idLook
          }
          Object.assign(look, mslId)
          lookApiService.updateLook(look)
            .then(data => {
              canvasAux.toBlob((blob) => {
                let file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                lookApiService.updateLookImagen(file, data.data.mslId)
                  .then(() => {
                    this.$root.$emit('mostrarAlerta', this.$t('lang.look.modificado'), 'info')
                })
                .catch(error => {
                  util.mostrarEnConsola('lookApiService - updateLookImagen', error, 'ERROR')
                })
              }, 'image/jpeg',data, this);
            })
            .catch(error => {
              util.mostrarEnConsola('lookApiService - updateLook', error, 'ERROR')
            })
        } else {
          lookApiService.addLook(look)
            .then(data => {
              canvasAux.toBlob((blob) => {
                let file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                lookApiService.updateLookImagen(file, data.mslId)
                  .then(() => {
                    this.$root.$emit('mostrarAlerta', this.$t('lang.look.creado'), 'info')
                    this.reiniciarLook()
                  })
                  .catch(error => {
                    util.mostrarEnConsola('lookApiService - updateLookImagen', error, 'ERROR')
                  })
              }, 'image/jpeg',data, this);

            })
            .catch(error => {
              util.mostrarEnConsola('lookApiService - addLook', error, 'ERROR')
            })
        }
        
      }
    },
    reiniciarLook() {
      // reiniciamos la dropzone
      this.titulo = ''
      this.descripcion = ''
      this.idLook = null
      this.elementosDropped = []
      var imagenes =  this.canvas.getObjects()
      imagenes.forEach(element => this.canvas.remove(element))
    },
    // Al mover un elemento en el canvas lo traemos al frente
     moveHandler: (function (e) {
        var movingObject = e.target;
        this.canvas.bringToFront(movingObject)
        //console.log(movingObject.get('left'), movingObject.get('top'));
    }),
    //evitamos que los elementos se puedan ir del canvas aunque dejamos una pequeño margen de 50 px
    preventBound: (function (e){
        var obj = e.target;
        if (obj.left < 0 - 50
        || obj.top < 0 - 50
        || obj.left + (obj.width * obj.scaleX) > obj.canvas.width + 50
        || obj.top + (obj.height * obj.scaleY) > obj.canvas.height + 50) {
            obj.top = obj._stateProperties.top
            obj.left = obj._stateProperties.left
            obj.scaleX = obj._stateProperties.scaleX
            obj.scaleY = obj._stateProperties.scaleY
            obj.setCoords()
          }
    })
  }
};

</script>
<style>
/* 
Styles below based on  http://www.html5rocks.com/en/tutorials/dnd/basics/ 
*/

/* Prevent the text contents of draggable elements from being selectable. */
[draggable] {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
    -khtml-user-drag: element;
    -webkit-user-drag: element;
    cursor: pointer;
}
</style>
